import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ptBR from 'vuetify/src/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({ lang: { locales: { ptBR }, current: 'ptBR' } });
